import { olHeaders } from './olHeaders';

export const useUserLoggedInConfigs = {
  config: {
    olHeaders,
    skip: false
  }
};

export const useFeatureFlagsConfigs = (user) => ({
  config: {
    skip: !user,
  },
  params: {
    legacyUserId: user?.details?.id.toString(),
    countryCode: user?.details?.countryCode
  }
});

export const useProductAssetsByUserConfigs  = (user) => {
  const config = {
    olHeaders,
    skip: !user
  };

  return { config };
};
